import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = { class: "absolute left-0 z-50 mt-1 overflow-hidden bg-white border border-gray-100 shadow-xl top-full w-80 rounded-xl" };
const _hoisted_2 = {
    class: "flex items-center justify-between h-12 px-4 border-b",
    style: { "border-color": "#f3f4f6" }
};
const _hoisted_3 = { class: "text-sm font-semibold text-gray-900" };
const _hoisted_4 = { class: "flex flex-col gap-4 p-4" };
const _hoisted_5 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_6 = {
    class: "flex items-center gap-2 px-3 border rounded-lg",
    style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb", "height": "36px" }
};
const _hoisted_7 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_8 = {
    class: "flex items-center gap-2 px-3 border rounded-lg",
    style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb", "height": "36px" }
};
const _hoisted_9 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_10 = { value: "" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "block mb-1 text-xs font-medium text-gray-500" };
const _hoisted_13 = { value: "" };
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "flex items-center justify-between px-4 pt-2 pb-4 border-t border-gray-100" };
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { IconX, IconCalendar } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationFilters',
    props: {
        modelValue: {},
        services: {},
        itineraries: {}
    },
    emits: ["apply", "close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const local = ref({ ...props.modelValue });
        function applyFilters() {
            emit("apply", { ...local.value });
            emit("close");
        }
        function clearFilters() {
            local.value = {};
            emit("apply", {});
            emit("close");
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("conversation.filters.title")), 1),
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close'))),
                        class: "p-1 text-gray-400 rounded-md hover:bg-gray-100"
                    }, [
                        _createVNode(_unref(IconX), { class: "w-4 h-4" })
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)("conversation.filters.date_from")), 1),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_unref(IconCalendar), { class: "flex-shrink-0 w-4 h-4 text-gray-400" }),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((local.value.dateFrom) = $event)),
                                type: "date",
                                class: "flex-1 text-sm text-gray-700 bg-transparent focus:outline-none"
                            }, null, 512), [
                                [_vModelText, local.value.dateFrom]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("conversation.filters.date_to")), 1),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(IconCalendar), { class: "flex-shrink-0 w-4 h-4 text-gray-400" }),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((local.value.dateTo) = $event)),
                                type: "date",
                                class: "flex-1 text-sm text-gray-700 bg-transparent focus:outline-none"
                            }, null, 512), [
                                [_vModelText, local.value.dateTo]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("conversation.filters.service")), 1),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((local.value.serviceId) = $event)),
                            class: "w-full px-3 text-sm border rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-eorange-400",
                            style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb", "height": "36px" }
                        }, [
                            _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("conversation.filters.all_services")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (s) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: s.id,
                                    value: s.id
                                }, _toDisplayString(s.name), 9, _hoisted_11));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, local.value.serviceId]
                        ])
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(t)("conversation.filters.itinerary")), 1),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((local.value.itineraryId) = $event)),
                            class: "w-full px-3 text-sm border rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-eorange-400",
                            style: { "background-color": "#f5f6fa", "border-color": "#e5e7eb", "height": "36px" }
                        }, [
                            _createElementVNode("option", _hoisted_13, _toDisplayString(_unref(t)("conversation.filters.all_itineraries")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.itineraries, (it) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: it.id,
                                    value: it.id
                                }, _toDisplayString(it.code), 9, _hoisted_14));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, local.value.itineraryId]
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                        onClick: clearFilters,
                        class: "text-sm font-medium text-gray-500 hover:text-gray-700"
                    }, _toDisplayString(_unref(t)("conversation.filters.clear")), 1),
                    _createElementVNode("button", {
                        onClick: applyFilters,
                        class: "px-4 py-1.5 text-sm font-medium text-white rounded-lg bg-eorange-400 hover:bg-eorange-500"
                    }, _toDisplayString(_unref(t)("conversation.filters.apply")), 1)
                ])
            ]));
        };
    }
});
